import { render } from "./Impressum.vue?vue&type=template&id=0cf6dd74"
const script = {}
script.render = render

export default script